var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.99859 9.17688C6.44871 9.17688 6.81359 8.81199 6.81359 8.36188C6.81359 7.91176 6.44871 7.54688 5.99859 7.54688C5.54848 7.54688 5.18359 7.91176 5.18359 8.36188C5.18359 8.81199 5.54848 9.17688 5.99859 9.17688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.14 5.265V4.64C9.14 3.29 8.815 1.5 6 1.5C3.185 1.5 2.86 3.29 2.86 4.64V5.265C1.46 5.44 1 6.15 1 7.895V8.825C1 10.875 1.625 11.5 3.675 11.5H8.325C10.375 11.5 11 10.875 11 8.825V7.895C11 6.15 10.54 5.44 9.14 5.265ZM6 9.87C5.165 9.87 4.49 9.19 4.49 8.36C4.49 7.525 5.17 6.85 6 6.85C6.83 6.85 7.51 7.53 7.51 8.36C7.51 9.195 6.835 9.87 6 9.87ZM3.675 5.22C3.635 5.22 3.6 5.22 3.56 5.22V4.64C3.56 3.175 3.975 2.2 6 2.2C8.025 2.2 8.44 3.175 8.44 4.64V5.225C8.4 5.225 8.365 5.225 8.325 5.225H3.675V5.22Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6edb1b7644d93ed83cf2b1801b12ed96.svg";
export { ForwardRef as ReactComponent };